<template>
  <v-row>
    <div v-if="showDialog" fullscreen scrollable persistent no-click-animation>
      <v-card style="height: 100vh; width: 100vw; overflow:auto;">
        <v-card-text @wheel="onWheel" class="pa-0">
          <v-container fluid scrollable  @wheel="onWheel">
            <ul class="white collection" style="border: 0px; width: 100%; list-style-type: none;">
              <li
                v-for="project in data"
                :key="project.id"
                style="padding: 10px; min-height: 60px; border-bottom: 1px solid #e0e0e0;"
              >
                <div>
                    <v-chip v-if="project.internalCode" class="ma-2" style="float: right;" color="primary">{{project.internalCode}}</v-chip>
                    <div v-if="project.shortName"><b><h3>{{ project.shortName  }}</h3></b></div>
                    <div v-if="project.description">{{ project.description }}</div>
                    <div v-if="project.fromDate"><b>{{ $t('wkt.client.projects.from_date') }}</b>: {{ formatOnlyDate(convertSimpleDateToDate(project.fromDate)) }}</div>
                    <div v-if="project.toDate"><b>{{ $t('wkt.client.projects.to_date') }}</b>: {{ formatOnlyDate(convertSimpleDateToDate(project.toDate)) }}</div>
                    <div v-if="project.client"><b>{{ $t('wkt.client.projects.client') }}</b>: {{ project.client }}</div>
                    <div v-if="project.address"><b>{{ $t('wkt.client.projects.address') }}</b>: {{ project.address }}</div>
                    <div v-if="project.contactPerson"><b>{{ $t('wkt.client.projects.contact_person') }}</b>: {{ project.contactPerson }}</div>
                    <div v-if="project.contactEmail"><b>{{ $t('wkt.client.projects.contact_email') }}</b>: {{ project.contactEmail }}</div>
                    <div v-if="project.contactPhone"><b>{{ $t('wkt.client.projects.contact_phone') }}</b>: {{ project.contactPhone }}</div>
                    <div v-if="project.observations"><b>{{ $t('wkt.client.projects.observations') }}</b>: {{ project.observations }}</div>
                    <div v-if="project.specialRequirements"><b>{{ $t('wkt.client.projects.special_requirements') }}</b>: {{ project.specialRequirements }}</div>
                </div>
              </li>
            </ul>
          </v-container>
        </v-card-text>
      </v-card>
    </div>
  </v-row>
</template>

<script>
import BaseModule from "../../common/BaseModule.js";
//import api from '../../../api/worktime'
import gwt from "../../../api/gwt";

export default {
  name: "ProjectsModule",
  mixins: [BaseModule],
  components: {},
  data() {
    return {
      showDialog: false,
      isLoading: false,
      data: {},
    };
  },
  methods: {
    onWheel(event) {
      event.stopPropagation();
    },
    onReveal() {
      this.open();
    },
    open() {
      this.showDialog = true;
      this.data = gwt.getSessionInformation().employeeProjects.filter(p => p.enabled);
    },
    close() {
      this.showDialog = false;
    },
  },
};
</script>
